import * as Yup from 'yup'

const assignCreditsSchema = Yup.object({
  assignFrom: Yup.string().required('Select user to assign credits from'),
  assignTo: Yup.string().required('Who would you like to assign credits to?'),
})

export default assignCreditsSchema
